import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StFieldContainer = styled.div<{
  noMargin?: boolean
  showMaxLength?: boolean
  $autoGrow?: boolean
}>`
  width: 100%;
  height: 100%;

  ${({ $autoGrow }) =>
    $autoGrow
      ? ''
      : `
    max-height: 110px;
    min-height: 110px;
  `}

  ${({ theme, noMargin, showMaxLength }) => `
    margin-bottom: ${noMargin ? '0px' : theme.UI.SpacingPx.Space2};
    & > label {
      margin-bottom: ${noMargin ? '0px' : theme.UI.SpacingPx.Space2};
      padding-bottom: ${showMaxLength ? theme.UI.SpacingPx.Space2 : 0};
    }
  `}
`

const StInputContainer = styled.label<{
  error: boolean
  $autoGrow?: boolean
  $maxHeight?: number
}>`
  overflow: ${({ $autoGrow }) => ($autoGrow ? 'visible' : 'hidden')};
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;

  font-size: 18px;
  line-height: 28px;

  transition: all 0.3s ease;

  ${({ theme, error, $autoGrow, $maxHeight }) => {
    return `
      background-color: ${error ? theme.Components.Input.ErrorFill : theme.Components.Input.Fill};
      border: 1px solid ${error ? theme.Components.Input.ErrorBorder : theme.Components.Input.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;
      color: ${error ? theme.Components.Input.ErrorText : theme.Components.Input.Text};

      > textarea {
        width: 100%;
        height: ${$autoGrow ? 'auto' : '100%'};
        ${$autoGrow ? 'resize: none;' : ''}
        ${$autoGrow ? 'min-height: unset;' : 'min-height: 100px;'}
        ${$autoGrow && $maxHeight ? `max-height: ${$maxHeight}px;` : ''}
        ${$autoGrow && $maxHeight ? 'overflow-y: auto;' : ''}

  @media ${breakpoints.m} {
    ${$autoGrow ? '' : 'min-height: 100px;'}
  }

        line-height: 22px;
        padding: ${theme.UI.SpacingPx.Space4};

        &::placeholder {
          color: ${theme.Components.Input.Placeholder};
        }

        &:disabled {
          color: ${theme.Components.Input.DisabledText};
          border-color: ${theme.Components.Input.DisabledBorder};
          background-color: ${theme.Components.Input.DisabledFill};
        }
      }

      &:focus-within {
        outline: none;

        ${
          error
            ? ``
            : `
        border-color: ${theme.Components.Input.ActiveBorder};
        background-color: ${theme.Components.Input.ActiveFill};

        `
        }
      }
    `
  }}
`

const StInputIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: 16px;
  right: 0px;
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
`

const stInputErrorContainer = styled.div``

const StCharacterCounter = styled.span`
  position: absolute;
  bottom: 4px;
  right: 12px;
  font-size: 10px;
  color: ${({ theme }) => theme.Colors.Neutrals.Darker};
`

export { StCharacterCounter, StFieldContainer, StInputContainer, StInputIcon, stInputErrorContainer }
